interface PerformanceFormatsProps {
  onConsultClick: () => void;
}

export default function PerformanceFormats({ onConsultClick }: PerformanceFormatsProps) {
  const formats = [
    {
      id: 1,
      title: 'The Mind Reading Stage Show',
      subtitle: 'High-Energy Headline Performance',
      capacity: '10 to 1,000+ guests',
      image: 'https://static.readdy.ai/image/784caf738992fff872ad90f0e356a90f/813e8678adf18eb09929c2f91b510f6f.jpeg',
      description: 'Interactive, amazing, and laugh-out-loud funny. A headline act that captivates large audiences with impossible demonstrations of mind reading, psychological influence, and audience participation that creates unforgettable shared experiences.',
      features: ['Full stage production', 'Interactive audience participation', 'Customizable to event theme', 'High-energy entertainment']
    },
    {
      id: 2,
      title: 'The Guest Mingle',
      subtitle: 'Strolling Mentalism',
      capacity: 'Intimate groups',
      image: 'https://static.readdy.ai/image/784caf738992fff872ad90f0e356a90f/cf068d4797c577248c0acfccd4addcb2.jpeg',
      description: 'Sophisticated ice-breaking. Mind-reading that happens in the guests\' hands during cocktail hours and mixers. Perfect for networking events, this format creates intimate moments of astonishment that spark conversations and connections.',
      features: ['Perfect for cocktail hours', 'Intimate close-up experiences', 'Natural ice-breaker', 'Flexible timing']
    },
    {
      id: 3,
      title: 'Team Building',
      subtitle: 'The Invisible Connection',
      capacity: '15-minute workshop',
      image: 'https://static.readdy.ai/image/784caf738992fff872ad90f0e356a90f/8186e6bbc8fc4283bdaa689264d43f25.jpeg',
      description: 'A high-value workshop where I teach teams how to overcome the fear of public speaking and master communication using the secret psychological tools of a professional mentalist. Educating, empowering, and highly entertaining.',
      features: ['Practical communication tools', 'Overcome speaking anxiety', 'Psychological techniques', 'Immediately applicable skills']
    }
  ];

  return (
    <section className="relative py-32 px-6 bg-black">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            What we Offer
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Flexible entertainment solutions designed for different event needs and audience sizes
          </p>
        </div>

        {/* Performance Cards */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {formats.map((format) => (
            <div 
              key={format.id}
              className="group bg-zinc-900 rounded-2xl border border-red-900/30 overflow-hidden hover:border-red-600 hover:shadow-2xl hover:shadow-red-600/20 transition-all duration-500 hover:-translate-y-2"
            >
              {/* Image Area */}
              <div className="relative h-96 overflow-hidden bg-white">
                <img 
                  src={format.image}
                  alt={format.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-zinc-900 via-transparent to-transparent opacity-60"></div>
                
                {/* Capacity Badge */}
                <div className="absolute top-4 right-4 px-4 py-2 bg-red-600 rounded-full">
                  <span className="text-white text-xs font-semibold">{format.capacity}</span>
                </div>
              </div>

              {/* Content Area */}
              <div className="p-6">
                <h3 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: 'Inter, sans-serif' }}>
                  {format.title}
                </h3>
                
                <p className="text-red-400 text-sm mb-4 font-medium">
                  {format.subtitle}
                </p>
                
                <p className="text-gray-400 text-sm leading-relaxed mb-6">
                  {format.description}
                </p>

                {/* Features */}
                <div className="space-y-2 mb-6">
                  {format.features.map((feature, index) => (
                    <div key={index} className="flex items-center gap-2">
                      <i className="ri-check-line text-red-500 text-sm"></i>
                      <span className="text-gray-400 text-xs">{feature}</span>
                    </div>
                  ))}
                </div>

                <button 
                  onClick={onConsultClick}
                  className="w-full px-6 py-3 bg-red-600/10 text-red-500 text-sm font-semibold rounded-lg hover:bg-red-600 hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Learn More
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}